/**
 * Centralized field descriptions for notification configuration fields.
 *
 * These descriptions are used as tooltip/info text across the platform —
 * both on single notification details and A/B test details summary views.
 * Any time a notification field needs a user-facing explanation, it should
 * be sourced from this file so the copy stays consistent.
 */

export const NOTIFICATION_FIELD_DESCRIPTIONS = {
    /** General section */
    status:
        'The current delivery status of this notification.',
    channels:
        'The platform channels this notification targets (Web, Native Apple, Native Android).',

    /** Delivery section */
    deliveryDateRange:
        'The window between the earliest scheduled send time and the latest expiry (send time + TTL).',
    deliveryStrategy:
        'How the notification is delivered — immediately, at a scheduled time, or in the subscriber\'s local timezone.',
    behaviors:
        'Special delivery behaviors applied to this notification, such as silent delivery.',

    /** Targeting section */
    targetedAudiences:
        'The subscriber segments this notification is sent to.',
    excludedAudiences:
        'Subscriber segments explicitly excluded from receiving this notification.',

    /** Content section */
    contentSources:
        'How notification content was created — manually, via Page Analyzer, or with Pushly AI.',

    /** Test-specific fields */
    testType:
        'Whether this test varies content, delivery timing, or both across its variants.',
    totalVariants:
        'The number of notification variants in this test, plus a winner notification if one has been promoted.',
} as const
